import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

const CssIconButton = styled(IconButton)({
  // color: 'primary.light'
});

export default CssIconButton;